import {Component, OnInit} from '@angular/core';
import {FixedPriceService} from "../../services/fixedPrice/fixed-price.service";
import { Router } from '@angular/router';
import { SeaModel } from 'src/app/models/sea/sea-model';
import { BehaviorSubject } from 'rxjs';
import { MinDTO } from 'src/app/models/min-dto';
import { AirModel } from 'src/app/models/air/air-model';
import { DecimalPipe } from 'src/app/shared/decimal.pipe';
import { SearchLogClickHistoryModel } from 'src/app/models/search-log-click-history.model';
import { ClickHistorySubject } from 'src/app/events/click-history.events';

export const onSelectFixedPrice = new BehaviorSubject<any>(null);
export const onSelectFixedPriceAir = new BehaviorSubject<any>(null);


@Component({
  selector: 'app-dashboard-fixed-prices',
  templateUrl: './dashboard-fixed-prices.component.html',
  styleUrls: ['./dashboard-fixed-prices.component.scss']
})
export class DashboardFixedPricesComponent implements OnInit{
    values: any;
    cwValue = 166.666667;

    selectedOperation = 'SEA';
    loading: boolean = true;

    constructor(private fixedPriceService: FixedPriceService, private router: Router, private decimalPipe: DecimalPipe) {
    }
    async ngOnInit() {
      this.loading = true;
      try {
        this.values = await this.fixedPriceService.searchDashboardPricesByCode().toPromise();
        this.loading = false;
      } catch {
        this.loading = false;
      }
        
    }
    onSelectOperation(type:string) {
      this.selectedOperation = type;
    }
    onSearch(data: any) {

      const clickHistoryModel = new SearchLogClickHistoryModel();
      clickHistoryModel.productName = 'main-banner';
      clickHistoryModel.info =  data.departureCode + '-' + data.arrivalCode
      clickHistoryModel.costType = data.type == 'SEA' ? 'FCL': 'AIR';
      ClickHistorySubject.next(clickHistoryModel);


    let model: any = null;
      if(data.type == 'SEA') {

        model = new SeaModel();
        model.readinessDate = new Date(); 
        model.departureCountry =  data.departureCountry;
        model.arrivalCountry =  data.arrivalCountry;
        model.containerType = data.seaContainerType;
        model.pieces  = 1;
        model.containerCount = 1; 
        model.tonnage =  18000; 
        model.isOnlinePrice = true;
        model.service = 'ATA';
        model.commodity = 'GENERALCARGO'; 
        model.goodPrice = 1500; 
        model.incoterm = 'FOB'; 
        model.operationType = 'FCL'; 
        model.stackable = true; 
        model.td = 'T'; 
        
       
        if(data.departure) {
          const minDepPort = new MinDTO();
          minDepPort.id = data.departure.id;
          minDepPort.name = data.departure.name;
          model.departurePort = minDepPort;
        }
        if(data.arrival) {
          const minArPort = new MinDTO();
          minArPort.id = data.arrival.id;
          minArPort.name = data.arrival.name;
          model.arrivalPort = minArPort;
        }     
        onSelectFixedPrice.next(model);
      }
      if(data.type == 'AIR') {
        model = new AirModel();
        model.readinessDate = new Date(); 
        model.departureCountry =  data.departureCountry;
        model.arrivalCountry =  data.arrivalCountry;
        model.pieces  = 1;
        model.isOnlinePrice = true;
        model.service = 'ATA';
        model.commodity = 'GCR'; 
        model.goodPrice = 1500; 
        model.incoterm = 'FOB'; 
        model.stackable = true; 
        model.td = 'T'; 
        model.totalVolume = data.volume;
        model.totalWeight = data.weight;
        model.packingType = 'CARTONS'
       
        if(data.departureAirport) {
          const minDepPort = new MinDTO();
          minDepPort.id = data.departureAirport.id;
          minDepPort.name = data.departureAirport.name;
          model.departurePort = minDepPort;
        }
        if(data.arrivalAirport) {
          const minArPort = new MinDTO();
          minArPort.id = data.arrivalAirport.id;
          minArPort.name = data.arrivalAirport.name;
          model.arrivalPort = minArPort;
        }   
        const calculatedCwg = (Number(String(model.totalVolume).replace(',', '.')) * this.cwValue);
        model.cwg =  Number(Number(this.decimalPipe.transform(calculatedCwg > model.totalWeight ? calculatedCwg : model.totalWeight)).toFixed())
        onSelectFixedPriceAir.next(model);  
      }

      
      this.router.navigate([`/home/${data.type == 'SEA' ? 'sea' : 'air'}`]);
    }

    async generateSeaModel(data: any) {
      const model = new SeaModel();
      model.readinessDate = new Date();
    }

}
